import { useState, useEffect } from 'react';

// Contraseña desde variables de entorno
const CORRECT_PASSWORD = process.env.REACT_APP_CONTROL_PANEL_PASSWORD;
const SESSION_DURATION = parseInt(process.env.REACT_APP_SESSION_DURATION_HOURS || '8') * 60 * 60 * 1000;
const MAX_ATTEMPTS = parseInt(process.env.REACT_APP_MAX_LOGIN_ATTEMPTS || '5');
const LOCKOUT_TIME = parseInt(process.env.REACT_APP_LOCKOUT_TIME_MINUTES || '15') * 60 * 1000;

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loginAttempts, setLoginAttempts] = useState(0);
  const [isLocked, setIsLocked] = useState(false);
  const [lockUntil, setLockUntil] = useState(null);

  useEffect(() => {
    checkAuth();
    checkLockStatus();
  }, []);

  const checkLockStatus = () => {
    const lockTime = localStorage.getItem('lockUntil');
    if (lockTime) {
      const lockUntilTime = parseInt(lockTime);
      if (Date.now() < lockUntilTime) {
        setIsLocked(true);
        setLockUntil(lockUntilTime);
      } else {
        // Limpiar bloqueo expirado
        localStorage.removeItem('lockUntil');
        localStorage.removeItem('loginAttempts');
        setIsLocked(false);
        setLoginAttempts(0);
      }
    }
  };

  const checkAuth = () => {
    const authenticated = localStorage.getItem('controlPanelAuthenticated');
    const loginTime = localStorage.getItem('loginTimestamp');
    
    // Verificar si la sesión es válida
    if (authenticated && loginTime) {
      const currentTime = Date.now();
      
      if (currentTime - parseInt(loginTime) < SESSION_DURATION) {
        setIsAuthenticated(true);
      } else {
        // Sesión expirada
        logout();
      }
    }
    
    // Cargar intentos de login
    const attempts = localStorage.getItem('loginAttempts');
    if (attempts) {
      setLoginAttempts(parseInt(attempts));
    }
    
    setIsLoading(false);
  };

  const login = (password) => {
    if (isLocked) {
      return { success: false, message: `Cuenta bloqueada. Intente nuevamente en ${Math.ceil((lockUntil - Date.now()) / 60000)} minutos.` };
    }

    if (password === CORRECT_PASSWORD) {
      // Login exitoso
      localStorage.setItem('controlPanelAuthenticated', 'true');
      localStorage.setItem('loginTimestamp', Date.now().toString());
      localStorage.removeItem('loginAttempts');
      localStorage.removeItem('lockUntil');
      setLoginAttempts(0);
      setIsLocked(false);
      setIsAuthenticated(true);
      return { success: true, message: 'Login exitoso' };
    } else {
      // Login fallido
      const newAttempts = loginAttempts + 1;
      setLoginAttempts(newAttempts);
      localStorage.setItem('loginAttempts', newAttempts.toString());

      if (newAttempts >= MAX_ATTEMPTS) {
        // Bloquear cuenta
        const lockTime = Date.now() + LOCKOUT_TIME;
        localStorage.setItem('lockUntil', lockTime.toString());
        setIsLocked(true);
        setLockUntil(lockTime);
        return { success: false, message: `Demasiados intentos fallidos. Cuenta bloqueada por ${LOCKOUT_TIME / 60000} minutos.` };
      }

      const remaining = MAX_ATTEMPTS - newAttempts;
      return { success: false, message: `Contraseña incorrecta. Intentos restantes: ${remaining}` };
    }
  };

  const logout = () => {
    localStorage.removeItem('controlPanelAuthenticated');
    localStorage.removeItem('loginTimestamp');
    setIsAuthenticated(false);
  };

  return {
    isAuthenticated,
    isLoading,
    isLocked,
    lockUntil,
    loginAttempts,
    MAX_ATTEMPTS,
    login,
    logout
  };
};